const BASE_IMG_URL = "https://exun-api.herokuapp.com/img";
export default BASE_IMG_URL;
